import React from "react";
import { PropsWithChildren } from "react";
import {useHasPermissions} from "../../hooks/useHasPermissions";
import {EASASPermissionKey} from "../../models/enum/permissions";

type ShowIfPermittedProps = PropsWithChildren<{
    permissions: EASASPermissionKey | EASASPermissionKey[]
}>

export function PermissionGuard(props: ShowIfPermittedProps) {
    const hasPermission = useHasPermissions(props.permissions)

    if (hasPermission) {
        return <>{props.children}</>
    }

    return <></>
}